module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [(_vm.theme === 'clipped') ? _c('div', {
    class: _vm.clippedClasses
  }) : _vm._e(), _vm._v(" "), (_vm.theme === 'bookmark') ? _c('div', {
    class: _vm.bookmarkClasses
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c9249a1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ribbon/ribbon.vue
// module id = 684
// module chunks = 85